import React from "react";
import { Link } from "react-router-dom";
import { TABLE_CONFIG } from "./HappySchoolDataTable";

// Hub các danh sách học sinh (mỗi danh sách là 1 bảng dữ liệu độc lập).
const HappySchoolStudentLists = () => {
  const items = Object.entries(TABLE_CONFIG).filter(([, cfg]) => cfg.group === "student");
  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ margin: "0 0 4px" }}>📁 Quản lý học sinh</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Mỗi mục là một bảng độc lập — thêm/sửa/xoá dòng, nhập/xuất Excel. Bấm vào để mở.
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 12, marginTop: 16 }}>
        <Link to="/happyschool/students" style={cardStyle} className="hs-list-card">
          <span style={{ fontSize: 26 }}>🧑‍🎓</span>
          <span style={{ fontWeight: 600, color: "#1f2937" }}>HSSV Đang học</span>
        </Link>
        {items.map(([key, cfg]) => (
          <Link key={key} to={cfg.route || `/happyschool/list/${key}`} style={cardStyle} className="hs-list-card">
            <span style={{ fontSize: 26 }}>{cfg.icon || "📄"}</span>
            <span style={{ fontWeight: 600, color: "#1f2937" }}>{cfg.title}</span>
          </Link>
        ))}
      </div>
      <style>{`.hs-list-card:hover{ border-color:#0ea5a3; background:#f0fdfa; transform:translateY(-1px); }`}</style>
    </div>
  );
};

const cardStyle = {
  display: "flex", alignItems: "center", gap: 12, padding: 14, border: "1px solid #e5e7eb",
  borderRadius: 10, background: "#fff", textDecoration: "none", color: "inherit", transition: "all .15s",
  boxShadow: "0 1px 2px rgba(0,0,0,.04)",
};

export default HappySchoolStudentLists;
